module.exports = __webpack_public_path__ + "img/cc.be1b7474.svg";